module.exports = __webpack_public_path__ + "img/ro-flag.600d32c2.svg";